import { render, staticRenderFns } from "./IconMealplanLinear.vue?vue&type=template&id=0385dcff&scoped=true"
import script from "./IconMealplanLinear.vue?vue&type=script&lang=js"
export * from "./IconMealplanLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0385dcff",
  null
  
)

export default component.exports